
import * as tripApis from "../apis/trip_apis";

//action constants
const TRIPS_CHANGE = "tripsChange";
const TRIPS_SEARCH_SUBMITTING = "tripsSearchSubmitting";
const TRIPS_SEARCH_SUBMITTED = "tripsSearchSubmitted";

const initState = () => ({
    submitting: false,
    error: "",
    info: "",
    driversEmails: "",
    trips: [],
    searchVal: ""
})

const mutations = {
    [TRIPS_CHANGE] (state, payload) {
        Object.assign(state, {[payload.name]:payload.value});
    },
    [TRIPS_SEARCH_SUBMITTING] (state) {
        Object.assign(state, {submitting: true, info: "", error: "", trips: []});
    },
    [TRIPS_SEARCH_SUBMITTED] (state, payload) {
        Object.assign(state, {submitting: false, trips: payload.trips, error: payload.error});
    },
};

const actions = {
    [TRIPS_CHANGE] ({commit}, payload) {
        commit(TRIPS_CHANGE, payload);
    },
    submitTripSearch({commit, state}, callback) {

        if(!state.searchVal){
            return;
        }

        commit(TRIPS_SEARCH_SUBMITTING);

        tripApis.searchTrips(state.searchVal)
            .then((results) => {
                commit(TRIPS_SEARCH_SUBMITTED, {trips: results})
                    if(callback) {
                        callback();
                    }
                },
                (results) => {
                    let error = !results.error? "Failed loading trips.": results.error;
                    commit(TRIPS_SEARCH_SUBMITTED, {info: "", "error": error});
                    if(callback) {
                        callback();
                    }
                })
    }
}

const tripsStore = {
    state: initState(),
    mutations: mutations,
    actions: actions,
}

export default tripsStore
